import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import router from '@/router'
import { clearObjEmptyPrama } from './formatData'
console.log('网关', process.env.VUE_APP_Path)
axios.defaults.baseURL = process.env.VUE_APP_Path
axios.defaults.timeout = 60000

axios.interceptors.request.use(config => {
  config.headers.customer = window.sessionStorage.getItem('customer') || ''
  // lowcode token
  config.headers['LINK-PWD-TOKEN'] = process.env.VUE_APP_LOWCODE_LINK_PWD_TOKEN
  if (config.url !== '/business/saas/login') {
    // 登录鉴权
    config.headers.token = window.sessionStorage.getItem('token') || ''
  }
  // get方法去除对象空元素
  if (config.method === 'get') {
    config.params = clearObjEmptyPrama(config.params)
  }
  if (config.responseType === 'blob') {
    config.data = clearObjEmptyPrama(config.data)
  }
  return config
}, error => {
  Promise.reject(error)
})

axios.interceptors.response.use((res: any) => {
  if (res.config.responseType === 'blob') {
    const result = res.data
    const head = res.headers['content-disposition']
    let fname = ''
    if (head) {
      try {
        const info: Array<string> = head.split(';')
        info.forEach(item => {
          if (item.indexOf('filename') >= 0) {
            fname = item.split('=')[1]
            const reg = new RegExp('"', 'g')
            fname = fname.replace(reg, '')
            // 终止循环
            throw new Error('break')
          }
        })
      } catch (err) {}
    }
    if (fname !== '') {
      const blob = new Blob([result])
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      // 预览二维码
      if (JSON.parse(res.config.data)?.params?.preview) {
        return href
      }
      downloadElement.download = decodeURIComponent(fname) // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href)
    } else {
      Message({ type: 'error', message: '数据异常，请重试' })
    }
  } else {
    if (res.status !== 200) {
      Message({ type: 'error', message: '数据加载失败，请稍后再试' })
      return Promise.reject(new Error(res.data))
    }
    // 后台约定的对象 => { code: 200, data: {}, message: '' }
    if (Object.prototype.toString.call(res.data) !== '[object Object]') {
      Message({ type: 'error', message: '数据加载失败，请稍后再试' })
      return Promise.reject(new Error(res.data))
    }

    if (res.data.code === 200) {
      return res.data.data
    } else if (res.data.code === 800000) {
      MessageBox({
        title: '操作提示',
        message: res.data.message,
        showCancelButton: false,
        confirmButtonText: '确定'
      })
      if (res.data.data) {
        return res.data.data
      }
    } else if (res.data.code === 100000) {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('userInfo')
      router.replace('/login')
    } else if (res.data.code === undefined) {
      // 不走我们后台接口时，没有code,直接返回接口返回值，列如七牛上传图片
      return res.data
    } else if (res.data.data && res.data.data.query_field_list) {
      // lowcode 接口
      return res.data
    } else {
      Message({ type: 'error', message: res.data.message })
    }
    return Promise.reject(new Error(res.data.message))
  }
}, error => {
  Message({ message: error.message, type: 'error', duration: 5000 })
  return Promise.reject(error)
})

/**
 * GET请求方法
 * @param {String} url 请求地址
 * @param {json} params 请求参数
 */
export function get<T> (url: string, params?: object) {
  return axios.get<T>(url, { params })
}

export function post<T> (url: string, data?: object) {
  return axios.post<T>(url, data)
}

export function upload () {
  // TODO 上传接口
}

export function downloadFile (url: string, json: object, params: object) {
  return axios({
    url,
    method: 'post',
    data: json,
    withCredentials: true,
    responseType: 'blob',
    params: params
  })
}

export default {
  get: get,
  post: post,
  downloadFile
}
